// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "form>span[data-v-00ed6d4c]{display:block}.timer[data-v-00ed6d4c]{position:absolute;right:50px;bottom:20px;color:red}.signUpBtnPosition[data-v-00ed6d4c]{position:inherit;margin-left:25%;font-size:16px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
